import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDJSI5dp23w3IFXj3Toe8Tm8WxPAbxe5h0",
  authDomain: "solyminxorders.firebaseapp.com",
  projectId: "solyminxorders",
  storageBucket: "solyminxorders.firebasestorage.app",
  messagingSenderId: "994917582438",
  appId: "1:994917582438:web:2c7fc3a44acc098b9d0fa7",
  measurementId: "G-23BQ4CG015"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
